import React from 'react';
import { useSelector } from 'react-redux';
import { useSuggestionsContext } from 'src/hooks/useSuggestionsContext';
import { ApplicationState } from 'store/store';
import { ESuggestionType, IProduct, ProductGroup } from '../model/Menu';
import { MenuSuggestionsAdd } from './MenuSuggestionsAdd';

export const useSuggestionModal = () => {
    const { menu } = useSelector((state: ApplicationState) => state.menu);
    const currency = useSelector(
        (state: ApplicationState) => state.settings.settings?.region?.currencyCode ?? 'GBP'
    );
    const context = useSuggestionsContext();

    const handleSuggestionsClose = React.useCallback(() => {
        context.setSuggestion(null);
        context.setSuggestedGroupProduct(undefined);
        context.setAddedProduct(null);
    }, [context]);

    const handleShowMoreProductInfo = React.useCallback(
        (product: IProduct | ProductGroup | undefined, suggestionType: ESuggestionType) => {
            if (!menu) {
                return;
            }
            handleSuggestionsClose();
            if (product) {
                context.setSuggestedGroupProduct(product);
                context.setShowMoreSuggestionInfo(true);
                context.setShowMoreSuggestionInfoType(suggestionType);
            }
        },
        [context, handleSuggestionsClose, menu]
    );

    const suggestionModal = React.useCallback(() => {
        const isAddOrReplace = context.addedProduct || context.replaceProduct;
        if (!(context.suggestion && isAddOrReplace && context.suggestedProduct)) {
            return null;
        }
        const addedItem = context.addedProduct || context.replaceProduct;
        if (!addedItem) {
            return null;
        }
        return (
            <MenuSuggestionsAdd
                open={!!context.suggestion}
                onClose={handleSuggestionsClose}
                showMoreInfo={handleShowMoreProductInfo}
                currency={currency}
                suggestion={context.suggestion}
                addedItem={addedItem}
                suggestedProduct={context.suggestedProduct}
            />
        );
    }, [
        context.addedProduct,
        context.replaceProduct,
        context.suggestedProduct,
        context.suggestion,
        currency,
        handleShowMoreProductInfo,
        handleSuggestionsClose
    ]);

    return { suggestionModal };
};
